import React from "react";
import Errors from "@morningtrain/react-errors";
import isArray from "lodash/isArray";
import AppContext from "./contexts/AppContext";

export default class Services extends React.Component {

    static contextType = AppContext;

    get app() {
        return this.context;
    }

    static get defaultProps() {
        return {
            global: false
        };
    }

    get services() {
        return (this.props.global === true) ? this.app.globalServices() : this.app.services();
    }

    renderNextService(services) {
        if (services.length === 0) {
            return (
                <Errors.Boundary>
                    {this.props.children}
                </Errors.Boundary>
            );
        }

        let Service = services.shift();

        let props = {};

        if (isArray(Service)) {
            if (typeof (Service[1]) !== 'undefined') {
                props = Service[1];
            }
            Service = Service[0];
        }

        return (
            <Service {...props}>
                {this.renderNextService(services)}
            </Service>
        );
    }

    render() {
        return this.renderNextService(this.services);
    }

}
